import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { Flexer } from '@ontruck/orc';

import { DistanceCell } from 'modules/Common/Details';
import StopCards from 'modules/Stop/Cards';

import GoogleMapsLink from 'modules/Common/GoogleMapsLink';

import { getShipperOrderDetailData } from 'redux/modules/shipper-order-detail/selectors';
import { SectionTitleStyled, CardsContainerStyled } from 'modules/detail/styled';

const t = {
  title: 'Stops',
};

const Content = ({ shipperOrder, fetching }) => {
  return (
    <>
      <SectionTitleStyled mBottom="S">
        {!fetching && !!shipperOrder ? (
          <>
            {(shipperOrder.stops || []).length} {t.title}, {}
            <DistanceCell {...shipperOrder} /> {}
            <Flexer.Parent inline mLeft="S">
              <GoogleMapsLink
                item={shipperOrder}
                skin="light"
                showDistance={false}
                idType="shipperorder"
              />
            </Flexer.Parent>
          </>
        ) : (
          t.title
        )}
      </SectionTitleStyled>
      {!fetching && !!shipperOrder && (
        <CardsContainerStyled>
          <StopCards item={shipperOrder} />
        </CardsContainerStyled>
      )}
    </>
  );
};

Content.propTypes = {
  shipperOrder: PropTypes.object,
};

export default connect((state) => {
  return {
    shipperOrder: getShipperOrderDetailData(state),
  };
})(Content);
